import { Injectable } from '@angular/core';
import {RecordStageEnum} from "../dto/enum/record.stage.enum";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FlowStateService {

    private propertyIdSubject = new BehaviorSubject<number | null>(null);
    private recordStageSubject = new BehaviorSubject<RecordStageEnum | null>(null);
    private currentStepSubject = new BehaviorSubject<string>('segments');
    private stepData: Map<string, any> = new Map(); // Almacena datos por paso

    // GETTERS
    get propertyId(): number | null {
        return this.propertyIdSubject.value;
    }

    get recordStage(): RecordStageEnum | null {
        return this.recordStageSubject.value;
    }

    get currentStep(): string {
        return this.currentStepSubject.value;
    }

    // SETTERS
    setPropertyId(id: number): void {
        this.propertyIdSubject.next(id);
    }

    setRecordStage(stage: RecordStageEnum): void {
        this.recordStageSubject.next(stage);
    }

    setCurrentStep(step: string): void {
        this.currentStepSubject.next(step);
    }

    // Paso → data parcial
    setStepData(step: string, data: any): void {
        this.stepData.set(step, data);
    }

    getStepData(step: string): any {
        return this.stepData.get(step);
    }

    clear(): void {
        this.propertyIdSubject.next(null);
        this.recordStageSubject.next(null);
        this.currentStepSubject.next('segments');
        this.stepData.clear();
    }
    getStepByRecordStage(stage: RecordStageEnum): string {
        switch (stage) {
            case RecordStageEnum.TO_REGISTER_LOCATION:
            case RecordStageEnum.ADDRESS:
                return 'address';
            case RecordStageEnum.TO_REGISTER_PAPERS:
                return 'papers';
            case RecordStageEnum.FEATURES_1:
                return 'details-primary';
            case RecordStageEnum.FEATURES_2:
                return 'details-secondary';
            case RecordStageEnum.MULTIMEDIA:
                return 'pictures';
            case RecordStageEnum.TAGS:
                return 'tags';
            case RecordStageEnum.AD:
                return 'ad';
            case RecordStageEnum.ADS:
                return 'third';
            case RecordStageEnum.PRICE:
                return 'price';
            case RecordStageEnum.COMPLETE:
                return 'success';
            default:
                return 'segments';
        }
    }

}
